/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { AjaxResponse } from '@src/common/ajax/types';
import { ajax } from '@src/common/ajax';
import { SelectOption } from '@src/common/types';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import {
  beUniqueSelectOption,
  fetchSelectOptions,
} from '@src/common/util/fetchSelectOptions';
import { EventFilters, EventTypePortalItem } from '../types';

export interface EventTypeInfo {
  eventTypePortalItems: EventTypePortalItem[];
  eventTypeSelectItems: SelectOption[];
}

export async function fetchFilters(): Promise<AjaxResponse<EventFilters>> {
  const [portalsResp, eventTypesResp] = await Promise.all([
    fetchPortals(),
    fetchEventTypes(),
  ]);
  const status =
    portalsResp.status > eventTypesResp.status
      ? portalsResp.status
      : eventTypesResp.status;
  const success = portalsResp.success && eventTypesResp.success;

  return {
    payload: {
      ...eventTypesResp.payload,
      portals: portalsResp.payload,
    },
    status,
    success,
  };
}

export async function fetchPortals(): Promise<AjaxResponse<SelectOption[]>> {
  return fetchSelectOptions(ApiUrl.portals);
}

export async function fetchEventTypes(): Promise<AjaxResponse<EventTypeInfo>> {
  const { payload, ...rest } = await ajax<{ content: EventTypePortalItem[] }>(
    {
      content: [],
    },
    ApiUrl.eventTypes,
    {
      method: 'get',
    }
  );

  const eventTypePortalItems = sanitizeEventTypesResponse(payload.content);

  const eventTypeSelectItems = eventTypePortalItems
    .map((item) => ({
      label: item.name,
      value: item.code,
    }))
    .filter(beUniqueSelectOption);

  return {
    payload: {
      eventTypePortalItems,
      eventTypeSelectItems,
    },
    ...rest,
  };
}

function sanitizeEventTypesResponse(
  content: EventTypePortalItem[]
): EventTypePortalItem[] {
  let eventTypePortalItems = Array.isArray(content) ? [...content] : [];
  eventTypePortalItems = eventTypePortalItems.filter((item) => !!item);
  return eventTypePortalItems.map((item) => {
    return {
      code: item.code ?? '',
      name: item.name ?? '',
      portalCode: item.portalCode ?? '',
    };
  });
}
